<template>
  <div class="content">
    <div class="tips">
      <img class="img" src="./imgs/no-content.png" />
      <div class="no-content">施工中，敬请期待~</div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  setup() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
.img {
  width: 120px;
  height: 120px;
  margin-bottom: 12px;
}
.content {
  position: relative;
  height: 100%;
}
.tips {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.no-content {
  color: #898a8e;
  font-weight: 500;
  font-size: 19px;
  text-align: center;
}
</style>
